import { makeStyles } from '@fluentui/react-components';
export var useCarouselListStyles = makeStyles({
    container: {
        // built in navigation paddles are positioned absolutely to the container
        position: 'relative',
        width: '100%',
    },
});
//# sourceMappingURL=CarouselList.styles.js.map